import styled from 'styled-components';

export const Container = styled.div`
  padding: 32px 16px;
`;
